
import {defineComponent, PropType} from "vue";
import {ProductFilterPickerPayload} from "@/models/payload/ProductFilterPickerPayload";
import {ProductFilterTypeEnum} from "@/models/enum/ProductFilterTypeEnum";
import ProductFilter from "@/components/layouts/catalog/product-filter/ProductFilter.vue";
import {generateUuid} from "@/helpers/functions/string";
import ButtonProductFilterPreview from "@/components/layouts/catalog/ButtonProductFilterPreview.vue";
import {AbilityContext} from "@/context/AbilityContext";
import {ProductFilterRestDto} from "@/api/pharma-cpc-mgmt/models";

export default defineComponent({
  name: "ProductFilterPicker",
  components: {ButtonProductFilterPreview, ProductFilter},
  emits: ['payloadChanged', 'productFilterChanged'],
  props: {
    payload: {
      type: Object as PropType<ProductFilterPickerPayload>,
      required: true,
    },
    productFilter: {
      type: Object as PropType<ProductFilterRestDto>,
      required: true
    },
    errors: {
      type: Object,
    }
  },
  data() {
    return {
      productFilterTypeEnum: ProductFilterTypeEnum,
      internalPayload: ProductFilterPickerPayload.cloneFrom(this.payload),
      initialCode: this.payload.code,
      initialType: this.payload.type,
      internalProductFilter: {...this.productFilter} as ProductFilterRestDto
    }
  },
  watch: {
    payload: {
      handler(newPayload: ProductFilterPickerPayload) {
        this.internalPayload = ProductFilterPickerPayload.cloneFrom(newPayload);
      },
      deep: true,
      immediate: false
    },
    internalPayload: {
      handler() {
        this.$emit('payloadChanged', this.internalPayload);
      },
      deep: true,
    }
  },
  computed: {
    canUseNamedProductFilter(): boolean {
      return AbilityContext.isAuthorizedForFeature('NAMED_PRODUCT_FILTER');
    },
  },
  methods: {
    isProductFilterType(type: ProductFilterTypeEnum): boolean {
      return this.internalPayload.type === type;
    },
    productFilterChanged(value: ProductFilterRestDto): void {
      this.internalProductFilter = value;
      this.$emit('productFilterChanged', this.internalProductFilter);
    },
    setProductFilterType(type: ProductFilterTypeEnum) {
      this.internalPayload.type = type;

      if (type === this.initialType) {
        this.internalPayload.code = this.initialCode;
      } else if (type === ProductFilterTypeEnum.CUSTOM) {
        this.internalPayload.code = generateUuid();
      } else if (type === ProductFilterTypeEnum.NAMED) {
        this.internalPayload.code = null;
      }
    },
  }
});
